import { Directive } from "@angular/core";

@Directive({
    selector: '[click]:not([disabled]):not(:disabled):not(.workflow_workspace--task):not([unity-button])',
    host: {
        'style': 'cursor: pointer'
    },
    standalone: false
})
export class ClickCursorDirective {}